<template>
  <div id="pageMoveLoadingPop" class="move-loading" role="dialog" aria-hidden="true" aria-modal="true" tabindex="-1">
    <div class="pop-bg-close ui-pop-close" aria-presentation="true"></div>
    <article class="pop-wrap">
      <div class="pop-body" tabindex="0">
        <span class="lottie-animation-2" aria-presentation="true"></span>
        <h2 class="loading-tit">페이지 이동중입니다.</h2>
        <!-- 서브텍스트 : 없으면 비노출 -->
        <div class="loading-txt">잠시만 기다려주세요.</div>
      </div>
    </article>
  </div>
</template>

<script setup>
import {onMounted, watchEffect} from "vue";
import lottie from 'lottie-web'
import {togglePop} from "@/utils/commonUi";

const props = defineProps({
  enable: {
    type: Boolean,
    default: false
  }
})

const loadAnimation = () => {
  const loading1 = document.querySelector('.lottie-animation-2')

  if (loading1) {
    lottie.loadAnimation({
      container: loading1, // 애니메이션을 표시할 DOM 요소
      renderer: 'svg', // SVG 렌더러 사용
      loop: true, // 애니메이션 반복 재생 여부
      autoplay: true, // 자동 재생 여부
      path: '/claim/web/lottie/pageLoading.json' // Lottie 애니메이션 JSON 파일 경로
    })
  }
}

watchEffect(() => {
  if (props.enable) {
    togglePop('pageMoveLoadingPop', true, false, {useTimeout: false});
  } else {
    togglePop('pageMoveLoadingPop', false, false, {useTimeout: false});
  }
})

onMounted(() => {
  loadAnimation()
})
</script>

<style scoped lang="scss">

</style>